<template>
    <div class="trialClass">
        <div class="trialClass-img">
            <h3>员工内部体验课</h3>
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/bg.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/zu.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/huodong.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/link.png" alt="" @click="goLink">
            <img src="../asset/images/class/erweima@2x.png" alt="">
        </div>
        <div class="classbtn">
            <img v-if="isStudy" @click="goPayment" src="../asset/images/class/btn@2x.png" alt="">
            <p v-if="!isStudy" @click="goStudy" class='classbtn-p'>立即学习</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "trialClass",
    data() {
        return {
            trainid: null,
            isStudy: true,
            payData: null,
            token: null,
        };
    },
    components: {},
    methods: {
        goLink(){
            // todo  打开链接
            window.open('https://www.wjx.cn/vj/wDlUFYR.aspx')
        },
        goStudy(){
            this.$router.push({
                    path: "/learning/Details",
                    query: {
                        id: this.trainid.referId
                    }
                });
        },
        findSaleGoodsPay(){
            this.$api.home.findSaleGoods().then((data) => {
               this.trainid = data.data;
            //    this.findGoodsById(this.trainid);
               if(this.token){
                    this.checkUserCanByGoods(this.trainid.id)
               }
            }) 
        },
        goPayment() {
            if (!this.token) {
                this.$router.push({ path: "/login" , query: {name: 'trialClass'}});
            } else {
                this.$router.push({
                    path: "/gongxin_payment",
                    query: {
                        id: this.trainid.id,
                        iswx:0,
                    }
                });
            }
        },
        // findGoodsById(id){
        //     let params = {
        //         id: id//this.$route.query.id
        //     }
        //     this.$api.home.findGoodsById({params}).then(data =>{
        //        this.payData = data.data;
        //        if(this.token){
        //             this.checkUserCanByGoods(this.payData.id)
        //        }
              
        //     })
        // },
        checkUserCanByGoods(id){ //查看商品是否购买；
              let params = {
               goodsId:id
            }
             this.$api.home.checkUserCanByGoods({params}).then(data =>{
                 this.isStudy = data.data;
            })
        },
    },
    mounted() {
        this.findSaleGoodsPay();
        this.token = localStorage.getItem("token")
            ? localStorage.getItem("token")
            : null;
    }
};
</script>

<style scoped lang="less">
.trialClass{
    font-size: 0;
    .classbtn{
        position: fixed;
        bottom: 0px;
        left: 0px;
        img{
            width: 100%;
            height: auto;
        }
        .classbtn-p{
            width: 100vw;
            height: 110px;
            line-height: 110px;
            text-align: center;
            background: chocolate;
            color: #fff;
            font-size: 32px;
        }
    }
    .trialClass-img{
        font-size: 0;
        padding-bottom: 110px;
        h3{
            text-align: center;
            font-size: 34px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            background: #0A0555;
            padding: 29px 0px;
        }
        img{
            display: inline-block;
            width: 100%;
            height: auto;
        }
        
    }
}
</style>
